import React from 'react';
import {DataFetcher} from '@aboutyou/data-fetcher';
import {
  useIsCategoryPage,
  useIsBrandPage,
  useIsArticleDetailPage,
  useIsBasketPage,
  useIsWishlistPage,
  useIsStoryPage,
  useIsDropPage,
  useIsOutfitDetailPage,
  useIsHomePage,
} from '@aboutyou/router';
import {lazy} from '@aboutyou/lazy-imports';
import {useDiscounts} from '../hooks/useDiscounts';
import {filterSimpleAndAppInstallIncentiveCampaigns} from '../discountsHelper';

const LazyDiscountStickyBar = lazy(() =>
  import('./DiscountStickyBar.eager').then(mod => ({
    default: mod.DiscountStickyBarEager,
  })),
);

export const DiscountStickyBar = () => {
  const request = useDiscounts();
  const isHomePage = useIsHomePage();
  const isCategory = useIsCategoryPage();
  const isBrandPage = useIsBrandPage();
  const isADP = useIsArticleDetailPage();
  const isBasket = useIsBasketPage();
  const isWishlist = useIsWishlistPage();
  const isStory = useIsStoryPage();
  const isOutfitDetailPage = useIsOutfitDetailPage();
  const isDropPage = useIsDropPage();

  return isCategory ||
    isHomePage ||
    isBrandPage ||
    isADP ||
    isBasket ||
    isWishlist ||
    isStory ||
    isOutfitDetailPage ||
    isDropPage ? (
    <DataFetcher
      request={request}
      Error={null}
      View={props =>
        filterSimpleAndAppInstallIncentiveCampaigns(props.discounts).length >
        1 ? (
          <LazyDiscountStickyBar discounts={props} />
        ) : null
      }
    />
  ) : null;
};
